import http from "../http-common";
import { Element } from "../models/elementModel";

class ElementDataService {
  async createElement(element: Element) {
    const json = JSON.stringify(element);
    return await http.post("/elements/create", json);
  }

  async updateElement(element: Element) {
    const json = JSON.stringify(element);
    return await http.post("/elements/update", json);
  }

  async deleteElements(elements: Element[]) {
    const json = JSON.stringify(elements);
    return await http.post("/elements/delete", json);
  }
  
  async moveElements(elements: Element[]) {
    const json = JSON.stringify(elements);
    return await http.post("/elements/move", json);
  }

  async undoRedoElements(elements: Element[]) {
    const json = JSON.stringify(elements);
    return await http.post("/elements/undoOrRedo", json);
  }

  async copyElements(elements: Element[]) {
    const json = JSON.stringify(elements);
    return await http.post("/elements/copy", json);
  }
}

export default new ElementDataService();